var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContactLocationImg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 116,
  height: 116,
  viewBox: "0 0 116 116"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 58,
  r: 58,
  fill: "#f0f0f0",
  "data-name": "Ellipse 10"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#7654fd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.8
}, /*#__PURE__*/React.createElement("path", {
  d: "M52.691 45.853A5.309 5.309 0 1 0 58 40.544a5.31 5.31 0 0 0-5.309 5.309",
  "data-name": "Path 442"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58 33.908a11.945 11.945 0 0 1 11.945 11.945c0 5.753-9.082 18.629-11.407 21.832a.667.667 0 0 1-1.076 0c-2.325-3.2-11.407-16.079-11.407-21.832A11.945 11.945 0 0 1 58 33.908",
  "data-name": "Path 443"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.58 64.052c4.835.957 8 2.555 8 4.364 0 2.932-8.317 5.309-18.582 5.309s-18.58-2.377-18.58-5.311c0-1.805 3.152-3.4 7.964-4.359",
  "data-name": "Path 444"
}))));
export default SvgContactLocationImg;